import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';

export default function useRouteCheck() {
	const router = useRouter();
	const searchParams = useSearchParams();
	const { pathname } = router;

	return {
		isExactFileRoutePath: (path: string) => path === pathname,
		hasSearchParams: searchParams.size > 0,
		hasParam: (paramName: string) => searchParams.has(paramName),
		getParam: (paramName: string) => searchParams.get(paramName),
		getAllParams: () => Object.fromEntries(searchParams.entries()),
		pathname,
	};
}
